import type { DegerFormulu, DegerFormuluKodu } from "@parafon/contracts/local-api";

/**
 * Türkçe sözlük · formul: başlıkların ⓘ balonundaki formül metinleri
 * (CLAUDE.md §6: formül metni tek sözlükten; anahtarlar sözleşmede,
 * `DEGER_FORMULU_KODLARI`).
 */
export const formul = {
  piyasaDegeri: {
    ad: "Piyasa değeri",
    formul: "Eldeki miktar × son birim fiyat; fiyatın para birimi rapor para birimine o günün kuruyla çevrilir.",
  },
  pay: {
    ad: "Pay",
    formul: "Varlığın değeri ÷ seçili kapsamdaki (bütün kasa, tek hesap ya da sanal hesap) bütün varlıkların değeri.",
  },
  maliyet: {
    ad: "Maliyet",
    formul:
      "Elde kalan partilerin alış tutarı + alış masrafı; her parti kendi alış gününün kuruyla çevrilir. Satılan partiler (FIFO) düşülür.",
  },
  mevcutGetiri: {
    ad: "Gerçekleşmemiş kazanç (mevcut getiri)",
    formul:
      "Mevcut getiri = eldekilerin değeri − maliyeti. Yüzde: ÷ cepten çıkan para (maliyet − temettüyle alınmış partilerin maliyeti).",
    temettuHaric:
      "Mevcut getiri = eldekilerin değeri − maliyeti. Yüzde: ÷ maliyet. Temettüler kural gereği hesaba katılmadı.",
  },
  gerceklesmisKazanc: {
    ad: "Gerçekleşmiş kazanç",
    formul: "Satış kazancı = satış hasılatı − satılan partilerin maliyeti (FIFO). Yüzde: ÷ satılan partilerin maliyeti.",
  },
  nakitAkisi: {
    ad: "Nakit akışı",
    formul: "Nakit akışı = temettü + faiz − masraf. Para yatırma ve çekme dahil değil.",
    temettuHaric: "Nakit akışı = faiz − masraf. Temettüler kural gereği hesaba katılmadı.",
  },
  gerceklesmisGetiri: {
    ad: "Gerçekleşmiş getiri",
    formul: "Gerçekleşmiş getiri = satış kazancı + temettü/faiz − masraf. Yüzde: ÷ satılan partilerin maliyeti.",
    temettuHaric:
      "Gerçekleşmiş getiri = satış kazancı + faiz − masraf. Temettüler kural gereği hesaba katılmadı. Yüzde: ÷ satılan partilerin maliyeti.",
  },
  yillikKarsilik: {
    ad: "Yıllık karşılık",
    formul:
      "Getiri oranı × 365 ÷ maliyet ağırlıklı yaş (gün). Getiri: geçmiş dahil; payda cepten çıkan para. 30 günden genç paraya yazılmaz.",
  },
  asilGetiri: {
    ad: "Asıl getiri",
    formul:
      "Asıl getiri = bugünkü değer (nakit dahil) − (yatırılan − çekilen). Yüzde: ÷ (yatırılan − çekilen). Satıştan gelen parayla yapılan alım yeni para sayılmaz; eldeki nakdin yetmediği alımın eksik kısmı para girişi sayılır. Yıllık: para ağırlıklı (her giriş kendi tarihinden).",
  },
  gunlukGetiri: {
    ad: "Günlük getiri",
    formul:
      "Günlük = bugünkü geçmiş dahil getiri − bir önceki günün geçmiş dahil getirisi. Yüzde: ÷ bir önceki günün değeri. O gün yapılan alım ve satımın tutarı farka girmez. Yabancı para birimli varlıkta fark kur değişimini de içerir.",
  },
  kesilenVergi: {
    ad: "Kesilen vergi",
    formul: "Satış stopajı + temettü/faiz stopajı. Kazanca dahil değil.",
  },
  toplamMaliyet: {
    ad: "Toplam maliyet",
    formul:
      "Toplam maliyet = yatırılan − çekilen (hesaba net giren para). Satıştan gelen parayla yapılan alım yeni para sayılmaz; eldeki nakdin yetmediği alımın eksik kısmı para girişi sayılır. Her giriş ve çekiş kendi gününün kuruyla.",
  },
  toplamVarlik: {
    ad: "Toplam varlık",
    formul: "Seçili kapsamdaki varlıkların bugünkü değeri + nakit bakiyesi. Nakit takibi kapalıysa yalnızca varlıklar.",
  },
  getiri: {
    ad: "Getiri",
    formul: "Getiri = toplam varlık − toplam maliyet. Yüzde: ÷ toplam maliyet.",
  },
  mevduatKarsiligi: {
    ad: "Mevduat karşılığı",
    formul:
      "Getiri yüzdesi × 365 ÷ ağırlıklı ortalama gün (basit, yıllık). Ağırlıklı ortalama gün = Σ(her girişin tutarı × hesapta kaldığı gün; çıkışlar eksiyle) ÷ toplam maliyet. 30 günden kısa sürede yazılmaz.",
  },
} satisfies Readonly<Record<DegerFormuluKodu, DegerFormulu>>;
